export const API = 'api';
export const DATA = 'data';
export const ERROR = 'error';
export const LOADING = 'loading';
export const HTTP_STATUS_CODES = {
  FORBIDDEN: 403,
  NOT_FOUND: 404
};
export const PREVENT_MULTIPLE_CALLS_SELECT_DELAY = 10;
export const NETWORK_IS_DOWN = 'network_is_down';
